import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { notification } from 'antd';
import { registerNotificationDismisser } from '../../utils/notificationRegistry';
import { dismissPresenceNotices, showPresenceNotice } from './presenceNotices';
import { API_DOMAIN } from '../constants';
import { bindPresenceContract, claimPresenceNotice } from './staffPresenceContract';
import { loadChatNotificationPreferences, useChatNotificationPreferences } from '../messaging/chatNotificationPreferences';

export default function useStaffPresence({ socket, channel, actorId, token, sessionId, openPresence }) {
  const [noticeApi, noticeHolder] = notification.useNotification();
  useEffect(() => registerNotificationDismisser(() => noticeApi.destroy()), [noticeApi]);
  const preferences = useChatNotificationPreferences(actorId);
  useEffect(() => { if (!preferences.staffPresence) dismissPresenceNotices(); }, [preferences.staffPresence]);
  const presentation = useRef();
  presentation.current = { openPresence, api: noticeApi };
  const [result, setResult] = useState({ identity: null, snapshot: null, error: null });
  const identity = `${actorId}:${sessionId}:${channel}`;
  useEffect(() => {
    if (!socket || !actorId || !token || !channel) return undefined;
    let active = true;
    const patch = changes => setResult(previous => ({ ...(previous.identity === identity ? previous : { snapshot: null, error: null }), identity, ...changes }));
    const dispose = bindPresenceContract({
      socket, channel,
      load: () => axios.get(`${API_DOMAIN}/messaging-v1/staff-presence`, {
        params: { channel_account_key: channel }, headers: { accessToken: token },
      }).then(response => response.data),
      publish: snapshot => patch({ snapshot }), error: error => patch({ error }),
      notify: async notice => {
        if (!loadChatNotificationPreferences(actorId).staffPresence) return;
        if (await claimPresenceNotice(`${actorId}:${channel}`, notice.key) && active
          && loadChatNotificationPreferences(actorId).staffPresence) {
          showPresenceNotice(notice, presentation.current);
        }
      },
    });
    return () => { active = false; dispose(); dismissPresenceNotices(); };
  }, [socket, channel, actorId, token, sessionId, identity]);
  return { ...(result.identity === identity && socket ? result : { snapshot: null, error: null }), noticeHolder };
}
